import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import { AppNotices } from '@/features/pwa/app-notices'
import { env } from '@/lib/env'
import type { RouterContext } from '@/lib/router-context'

const Devtools = env.DEV
  ? lazy(async () => {
      const [{ TanStackRouterDevtools }, { ReactQueryDevtools }] = await Promise.all([
        import('@tanstack/react-router-devtools'),
        import('@tanstack/react-query-devtools'),
      ])
      return {
        default: () => (
          <>
            <TanStackRouterDevtools position="bottom-right" />
            <ReactQueryDevtools buttonPosition="bottom-left" />
          </>
        ),
      }
    })
  : () => null

// The app lives under `_app`, in the shell; `login` renders bare beside it.
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: () => (
    <div className="p-6 text-center text-muted-foreground">Page not found.</div>
  ),
})

function RootLayout() {
  return (
    <>
      <Outlet />
      <AppNotices />
      <Suspense fallback={null}>
        <Devtools />
      </Suspense>
    </>
  )
}
